// @ngInject
function ArticleCollectionsApiService(ResourcesService) {

  var endpoint = 'articlecollections';

  return {
    listAllArticleCollections: ResourcesService.apiFactory.get(endpoint + '/briefs'),
    listAllCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
    getArticleCollectionById: ResourcesService.apiFactory.get(endpoint),
    saveArticleCollection: ResourcesService.apiFactory.save(endpoint + '/save', 'ArticleCollection'),
    updateArticleCollection: ResourcesService.apiFactory.save(endpoint + '/update', 'ArticleCollection')
  };
}

angular
  .module('articlecollections.api', [])
  .factory('ArticleCollectionsApiService', ArticleCollectionsApiService);
